import { createSlice } from "@reduxjs/toolkit";

export const confirmationModelOnClickEnum = {
   SAVE: "SAVE",
   COMPLETE: "COMPLETE",
   EDIT: "EDIT",
   END_OF_DAY: "END_OF_DAY",
   null: false
};

const initialState = {
   currentUserFinishedBoxes: 0,
   isFinishedBoxLoading: false,
   isDataLoading: false,
   showConfirmationModelForExceedValue: false,
   handleSaveForExceedValueProceed: false,
   isConversionSessionStarted: false,
   allProducts: [],
   allAccount: [],
   allOrganization: [],
   allProductionLineData: [],
   groupByWholeDayWrapping: [],
   userCountModelActionTrigger: false,
   isWrappingCompleted: false
};

export const WrapSlice = createSlice({
   name: "wrap",
   initialState: initialState,
   reducers: {
      resetWrappingState: (state) => {
         const { currentUserFinishedBoxes, allProducts, groupByWholeDayWrapping, ...remainingState } = initialState;
         Object.assign(state, remainingState);
      },
      setAllProducts: (state, action) => {
         state.allProducts = action.payload;
      },
      setAllAccount: (state, action) => {
         state.allAccount = action.payload;
      },
      setAllOrganization: (state, action) => {
         state.allOrganization = action.payload;
      },
      setAllProductionLineData: (state, action) => {
         state.allProductionLineData = action.payload;
      },
      setCurrentUserFinishedBoxes: (state, action) => {
         state.currentUserFinishedBoxes = action.payload;
      },
      setIsFinishedBoxLoading: (state, action) => {
         state.isFinishedBoxLoading = action.payload;
      },
      setIsDataLoading: (state, action) => {
         state.isDataLoading = action.payload;
      },
      setShowConfirmationModelForExceedValue: (state, action) => {
         state.showConfirmationModelForExceedValue = action.payload;
      },
      setHandleSaveForExceedValueProceed: (state, action) => {
         state.handleSaveForExceedValueProceed = action.payload;
      },
      setIsConversionSessionStarted: (state, action) => {
         state.isConversionSessionStarted = action.payload;
      },
      setGroupByWholeDayWrapping: (state, action) => {
         state.groupByWholeDayWrapping = action.payload;
      },
      setUserCountModelActionTrigger: (state, action) => {
         state.userCountModelActionTrigger = action.payload;
      },
      setIsWrappingCompleted: (state, action) => {
         state.isWrappingCompleted = action.payload;
      },
   },
});

export const wrapActions = WrapSlice?.actions;
